var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutUsArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204,
    height: 204,
    viewBox: "0 0 204 204",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_912_345)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.226 58.6709C159.747 74.0185 149.144 86.4475 135.753 96.1049C115.53 110.689 88.9478 118.958 67.2137 121.339C53.5541 122.837 43.8123 119.284 30.2173 117.807C29.6667 117.747 29.1718 118.145 29.1122 118.695C29.0516 119.243 29.4503 119.741 29.9998 119.798C43.7539 121.293 53.6134 124.847 67.4329 123.332C89.4699 120.918 116.419 112.518 136.926 97.7303C150.686 87.807 161.546 75.0052 166.15 59.233C166.306 58.7016 166.002 58.1457 165.471 57.9904C164.939 57.8351 164.381 58.1396 164.226 58.6709Z",
    fill: "url(#paint0_linear_912_345)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9943 120.029C27.0428 120.037 27.3663 120.083 27.6328 120.151C28.7394 120.424 30.6321 121.079 32.9709 122.047C40.8126 125.303 53.6423 132.082 58.5015 140.357C58.7819 140.834 59.3958 140.993 59.8731 140.712C60.3505 140.432 60.5122 139.819 60.2318 139.342C55.1759 130.732 41.8981 123.582 33.7382 120.196C32.6449 119.744 31.643 119.354 30.7659 119.04C33.531 118.366 36.3079 117.764 39.0989 117.192C47.134 115.547 53.7445 112.46 60.3711 107.524C60.8145 107.195 60.9065 106.565 60.5755 106.123C60.2468 105.68 59.6166 105.588 59.1743 105.919C52.7954 110.668 46.432 113.645 38.6981 115.228C35.0511 115.977 31.4231 116.778 27.8202 117.715C27.4617 117.808 26.5325 118.061 26.4079 118.117C25.6966 118.434 25.7918 119.088 25.82 119.231C25.833 119.301 26.0457 120.151 26.9943 120.029ZM26.8103 118.033C26.7842 118.037 26.757 118.039 26.7286 118.044C26.7513 118.039 26.7786 118.037 26.8103 118.033Z",
    fill: "url(#paint1_linear_912_345)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_912_345",
    x1: 164.25,
    y1: 54.6016,
    x2: 176.03,
    y2: 121.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_912_345",
    x1: 59.0237,
    y1: 102.775,
    x2: 36.0758,
    y2: 147.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_912_345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153.133,
    height: 153.133,
    fill: "white",
    transform: "translate(138.571) rotate(64.8099)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsArrow);
export default __webpack_public_path__ + "static/media/aboutUsArrow.8dc8edfcc42c7393ceac31640eaadacb.svg";
export { ForwardRef as ReactComponent };